// Add your custom JS here.

// JS for toggle menu 
// document.addEventListener('DOMContentLoaded', function() {
//     const menu = document.getElementById('menu');
//     const toggleMenuButton = document.getElementById('toggleMenuButton');
//     const menuButtonText = toggleMenuButton.querySelector('.menu-button-text');
//     const burgerMenu = toggleMenuButton.querySelector('.burger-menu');

//     toggleMenuButton.addEventListener('click', function() {
//         // Toggle class 'open' on menu and 'change' on burger menu
//         menu.classList.toggle('open');
//         document.body.classList.toggle('menu-active');
//         burgerMenu.classList.toggle('menu-open');

//         // Update the button text accordingly
//         if (menu.classList.contains('open')) {
//             menuButtonText.textContent = 'Close';
//         } else {
//             menuButtonText.textContent = 'Menu';
//         }
//     });
// });


document.addEventListener('DOMContentLoaded', function () {
    const menu = document.getElementById('menu');
    const toggleMenuButton = document.getElementById('toggleMenuButton');
    const menuButtonText = toggleMenuButton.querySelector('.menu-button-text');
    const burgerMenu = toggleMenuButton.querySelector('.burger-menu');

    toggleMenuButton.addEventListener('click', function () {
        toggleMenu();
    });

    document.addEventListener('click', function (event) {
        var isClickInsideMenu = menu.contains(event.target);
        var isClickInsideButton = toggleMenuButton.contains(event.target);

        if (!isClickInsideMenu && !isClickInsideButton && menu.classList.contains('open')) {
            toggleMenu();
        }
    });

    function toggleMenu() {
        // Toggle class 'open' on menu and 'change' on burger menu
        menu.classList.toggle('open');
        document.body.classList.toggle('menu-active');
        burgerMenu.classList.toggle('menu-open');

        // Update the button text accordingly
        if (menu.classList.contains('open')) {
            menuButtonText.textContent = 'Close';
        } else {
            menuButtonText.textContent = 'Menu';
        }
    }
});






// script for header fixed 

// const navigation = document.querySelector('.fixed-top');
// const navOffsetTop = navigation.offsetTop;

// window.addEventListener('scroll', function() {
//     if (window.pageYOffset > navOffsetTop) {
//         navigation.classList.add('nav-fixed');
//     } else {
//         navigation.classList.remove('nav-fixed');
//     }
// });

// if (window.pageYOffset > navOffsetTop) {
//     navigation.classList.add('nav-fixed');
// }






// create a custom cursor effect 

// Lo and behold, we birth the cursor from the ether
const cursor = document.createElement('div');
cursor.classList.add('custom-cursor');
document.body.appendChild(cursor);

// The sacred cows of CSS transition applied to our cursor
cursor.style.transition = 'left 0.1s linear, top 0.1s linear';

// To move the cursor, we must be as graceful as the gentle breeze
document.addEventListener('mousemove', e => {
    // We ask, nay, implore that smoothness be applied
    requestAnimationFrame(() => {
        cursor.style.left = `${e.clientX}px`;
        cursor.style.top = `${e.clientY}px`;
    });
});

// Now we call upon the anchors, the stones in our stream
document.querySelectorAll('a, .link').forEach(el => {
    // As the mouse caresses the anchor, our cursor blossoms
    el.addEventListener('mouseover', () => {
        cursor.style.transform = 'translate(-50%, -50%) scale(2)';
        cursor.style.transition = 'transform 0.25s ease-out';
    });

    // When the mouse retreats, our cursor gracefully returns to its humble beginnings
    el.addEventListener('mouseout', () => {
        cursor.style.transform = 'translate(-50%, -50%) scale(1)';
        cursor.style.transition = 'transform 0.25s ease-out';
    });
});





jQuery(document).ready(function ($) {

    // slider 'our-results' in homepage 
    // $('.our-results').slick({
    //     slidesToShow: 2,
    //     slidesToScroll: 2,
    //     arrows: true,
    //     dots: false,
    //     autoplay: false,
    //     autoplaySpeed: 2000,
    //     infinite: false,
    //     draggable: false,
    //     responsive: [{
    //         breakpoint: 768,
    //         settings: {
    //             slidesToShow: 1,
    //             slidesToScroll: 1
    //         }
    //     }]
    // });

    // slider 'creative-space' in homepage 
    $('.creative-space-row').slick({
        infinite: false,
        draggable: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        autoplay: false,
        autoplaySpeed: 2000,

    });

    // testimonial slider 
    $('.testimonial-row').slick({

        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: 5000,        
        responsive: [
            { 
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,

                }
            }
        ]
    });


    // javascript for vide play pause on mouse hove on  'our-results' in homepage 
    // jQuery(".myvideos").on("mouseover", function(//event) {
    //     this.play();
    // }).on('mouseout', function(event) {
    //     this.pause();
    // });






    // // text animation jquary 
    // var text = $('.animate-text').text();
    // var splitText = text.split("");

    // $('.animate-text').html("");

    // $.each(splitText, function(i, v) {
    //     if (v === ' ') {
    //         // Add a space using &nbsp; (Non-breaking space in HTML)
    //         $('.animate-text').append($('<span>', { html: '&nbsp;' }));
    //     } else {
    //         var span = $("<span>", {
    //             class: "animate-letter",
    //             text: v
    //         });
    //         $('.animate-text').append(span);
    //     }
    // });

    // // if 2 line text animation jquary 
    // var text = $('.animate-text2').text();
    // var splitText = text.split("");

    // $('.animate-text2').html("");

    // $.each(splitText, function(i, v) {
    //     if (v === ' ') {
    //         // Add a space using &nbsp; (Non-breaking space in HTML)
    //         $('.animate-text2').append($('<span>', { html: '&nbsp;' }));
    //     } else {
    //         var span = $("<span>", {
    //             class: "animate-letter",
    //             text: v
    //         });
    //         $('.animate-text2').append(span);
    //     }
    // });

    // // text animation jquary 
    $('.animate-text').each(function () {
        var text = $(this).text();
        var splitText = text.split("");

        $(this).empty();

        $.each(splitText, function (i, v) {
            if (v === ' ') {
                $(this).append($('<span>', { html: '&nbsp;' }));
            } else {
                var span = $("<span>", {
                    class: "animate-letter",
                    text: v
                });
                $(this).append(span);
            }
        }.bind(this)); // This 'bind' ensures that 'this' inside the function also refers to the current '.animate-text' instance.
    });

    // // activa class add while animate heading is comming 
    $(document).ready(function () {
        function isScrolledIntoView(elem) {
            var documentViewTop = $(window).scrollTop();
            var documentViewBottom = documentViewTop + $(window).height();
            var elemTop = $(elem).offset().top;
            var elemBottom = elemTop + $(elem).height();
            //returns true if element is visible
            return ((elemBottom <= documentViewBottom) && (elemTop >= documentViewTop));
        }
        // On scroll, check each element in .animate-text class
        $(window).scroll(function () {
            $('.animate-text').each(function () {
                if (isScrolledIntoView(this)) {
                    $(this).addClass('active'); //Add active class if element in viewport
                }
            });
        });
        // Trigger scroll event on load so slide on the first section will apply active class automatically
        $(window).trigger('scroll');
    });




});







// var text = document.getElementById('animate-text').innerText;
// var splitText = text.split("");
// document.getElementById('animate-text').innerHTML = "";

// for (let i = 0; i < splitText.length; i++) {
//     var span = document.createElement("span");
//     span.className = "animate-letter";
//     span.innerText = splitText[i];
//     document.getElementById('animate-text').appendChild(span);
// }


let animation = bodymovin.loadAnimation({
    container: document.getElementById('lottie-animation'), // the dom element that will contain the animation
    renderer: 'svg',
    loop: false,
    autoplay: true,
    path: '/wp-content/themes/understrap-child-main/img/header-scribble.json' // the path to the animation json
});